import { render, staticRenderFns } from "./AvisoLegal.vue?vue&type=template&id=3cca8283&scoped=true&"
import script from "./AvisoLegal.vue?vue&type=script&lang=js&"
export * from "./AvisoLegal.vue?vue&type=script&lang=js&"
import style0 from "./AvisoLegal.vue?vue&type=style&index=0&id=3cca8283&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca8283",
  null
  
)

export default component.exports